








































import Vue from 'vue'
import {mapActions, mapState, mapGetters} from 'vuex'
// moment
import moment from 'moment'
import 'moment/locale/it'
import { descriptionForSegnalazioneState } from '@/utils_report'

export default Vue.extend({
    data: () => ({
        urlPhoto: ''
    }),
    computed: {
        ...mapGetters('user', ['eUnOperatoreGestionaleReport']),
        ...mapState('reportMappa', ['segnalazioneMostrata', 'categorieSegnalazioni'])
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        descriptionForSegnalazioneState,
        descriptionForTipoSegnalazione(tipo_segnalazione_id): string {
            // cerco descrizione del tipo di segnalazione
            let tipi_segnalazioni = this.categorieSegnalazioni.reduce((acc, val) => acc.concat(val.tipi_segnalazione), [])
            
            return tipi_segnalazioni.find(obj => { return obj.id === tipo_segnalazione_id }).descrizione
        
        },
        descriptionCategoriaForTipoSegnalazione(tipo_segnalazione_id): string {
            // cerco descrizione della categoria a partire dal tipo
            let tipi_segnalazioni = this.categorieSegnalazioni
                                        .reduce(
                                            (acc, val) => { 
                                                let type_segnalazione = []
                                                val.tipi_segnalazione.forEach((tipo) => {
                                                    type_segnalazione.push({
                                                        ...tipo,
                                                        categoria_descrizione: val.descrizione
                                                    })
                                                })
                                                
                                                return acc.concat(type_segnalazione)
                                            }, 
                                        [])
            
            return tipi_segnalazioni.find(obj => { return obj.id === tipo_segnalazione_id }).categoria_descrizione
        
        },
        // la data di rilevamento scritta in modo leggibile
        dataParsata: (data) => moment(data).format('DD MMMM YYYY')
    },
    mounted() {
        // date italiane
        moment.locale('it')
    }
})
